/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AppService } from '../api.service';
import { ProjectsService } from './project.service';
import { SocialAuthService } from '@abacritt/angularx-social-login';
import { LocalStorageService } from './localstorage.service';
import { CartService } from './cart.service';
@Injectable({
  providedIn: 'root'
})
export class AuthService {
  constructor(private _as:AppService, private router:Router,private _project:ProjectsService,private socialAuthService: SocialAuthService,private localStorageService: LocalStorageService, private _cart:CartService) { }

  socialSignIn(data:any){
    const url = this._as.api_base_url + 'renovarz/google_login/';
    return this._as.postRequest(url, data, false).toPromise();
  }
  sendOtp(data:any){
    const url = this._as.api_base_url + 'renovarz/login_signup_otp/';
    return this._as.postRequest(url, data, false).toPromise();
  }

  verifyOtp(data:any){
    const url = this._as.api_base_url + 'renovarz/otp_verification/';
    return this._as.postRequest(url, data, false).toPromise();
  }
  setLocalStorage(res:any){
    this.localStorageService.setItem('user_info',JSON.stringify(res));
    this._as.isUserLoggedIn = true;
  }
  onLogout() {
    try{
      const token = (JSON.parse(this.localStorageService.getItem('user_info') || "" || "{}").token.access_token);
      const url = this._as.api_base_url + 'renovarz/logout/?token=' + token;
      this._as.getRequest(url, true).subscribe(() => {
          this._as.isUserLoggedIn = false;
          this._as.user_info = {};
          this.removerValueLocalstorage();
          this._as.isLoggedInSubject.next(false);
          this.router.navigate(['/']);
          
      },
      (err:any) =>{
       if(err){
        this._as.isUserLoggedIn = false;
        this._as.user_info = {};
        this.removerValueLocalstorage();
        this.router.navigate(['/']);
        // console.log("E ===============>")
       }
      })
    }catch(e){
      // console.log("erro ===============>")
      this._as.isUserLoggedIn = false;
      this._as.user_info = {};
      this.removerValueLocalstorage();
      this.router.navigate(['/']);
    }
    this._project.seleted_productList = [];
}


removerValueLocalstorage() {
  if(this.socialAuthService){
    this.socialAuthService.signOut().then().catch();
  }
 this.localStorageService.removeItem('user_info');
 this.localStorageService.removeItem('expiry_time');
 this.localStorageService.removeItem('Doneredirectononsame');
 this.localStorageService.removeItem('redirectonsame');
 this.localStorageService.removeItem('isproductback');
 this.localStorageService.removeItem('selectedProject');
 this.localStorageService.removeItem('mobile');
 this.localStorageService.removeItem('min_budget');
 this.localStorageService.removeItem('trial_end_date');
 this.localStorageService.removeItem('popup');
 this.localStorageService.removeItem('isNearbydealerOpen');
 this.localStorageService.removeItem('gustBudget');
 this.localStorageService.removeItem('redirectTo');
this._cart.sample_count = 0;
 this._project.selectedProject=undefined;
}
}
